//google auth

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { GoogleLogin } from '@react-oauth/google';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
  
//   const navigate = useNavigate();

//   const API_URL = 'https://your-api-gateway.com/login';
//   const GOOGLE_API_URL = 'https://your-api-gateway.com/google-auth';
//   const API_KEY = 'your-public-api-key';

//   // ------------------------------
//   // Normal LOGIN Handler
//   // ------------------------------
//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       const response = await fetch(API_URL, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'x-api-key': API_KEY,
//         },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await response.json();

//       if (!response.ok) throw new Error(data.message || 'Login failed');

//       localStorage.setItem('authToken', data.token);
//       navigate('/dashboard');

//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ------------------------------
//   // GOOGLE LOGIN SIGNUP Handler
//   // ------------------------------
//   const handleGoogleLogin = async (googleData) => {
//     setError('');
//     setLoading(true);

//     try {
//       const response = await fetch(GOOGLE_API_URL, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'x-api-key': API_KEY,
//         },
//         body: JSON.stringify({
//           credential: googleData.credential,
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) throw new Error(data.message || 'Google Login Failed');

//       localStorage.setItem('authToken', data.token);
//       navigate('/dashboard');

//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ------------------------------
//   // Signup Redirect
//   // ------------------------------
//   const handleSignupRedirect = () => {
//     navigate('/signup');
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.card}>
//         <h2 style={styles.header}>Welcome Back</h2>

//         {error && <div style={styles.error}>{error}</div>}

//         {/* Normal Login Form */}
//         <form onSubmit={handleLogin} style={styles.form}>
//           <div style={styles.inputGroup}>
//             <label style={styles.label}>Email</label>
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//               style={styles.input}
//               placeholder="Enter your email"
//             />
//           </div>

//           <div style={styles.inputGroup}>
//             <label style={styles.label}>Password</label>
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//               style={styles.input}
//               placeholder="Enter your password"
//             />
//           </div>

//           <button type="submit" disabled={loading} style={styles.button}>
//             {loading ? 'Verifying...' : 'Login'}
//           </button>
//         </form>

//         <div style={{ margin: "20px 0", textAlign: "center" }}>
//           <strong>OR</strong>
//         </div>

//         {/* Google Login Button */}
//         <GoogleLogin
//           onSuccess={(credentialResponse) => handleGoogleLogin(credentialResponse)}
//           onError={() => setError("Google Login Failed")}
//         />

//         <div style={styles.footer}>
//           <p>Don't have an account?</p>
//           <button onClick={handleSignupRedirect} style={styles.linkButton}>
//             Sign up here
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };


// // ---- Your styles (unchanged) ----
// const styles = {
//   container: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100vh',
//     backgroundColor: '#f0f2f5',
//   },
//   card: {
//     padding: '2rem',
//     borderRadius: '10px',
//     backgroundColor: 'white',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//     width: '100%',
//     maxWidth: '400px',
//   },
//   header: {
//     textAlign: 'center',
//     marginBottom: '1.5rem',
//     color: '#333',
//   },
//   form: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '1rem',
//   },
//   inputGroup: {
//     display: 'flex',
//     flexDirection: 'column',
//     textAlign: 'left',
//   },
//   label: {
//     marginBottom: '0.5rem',
//     fontSize: '0.9rem',
//     color: '#666',
//   },
//   input: {
//     padding: '0.75rem',
//     borderRadius: '5px',
//     border: '1px solid #ccc',
//     fontSize: '1rem',
//   },
//   button: {
//     padding: '0.75rem',
//     borderRadius: '5px',
//     border: 'none',
//     backgroundColor: '#007bff',
//     color: 'white',
//     fontSize: '1rem',
//     cursor: 'pointer',
//     marginTop: '1rem',
//   },
//   error: {
//     color: 'red',
//     backgroundColor: '#ffe6e6',
//     padding: '0.5rem',
//     borderRadius: '5px',
//     marginBottom: '1rem',
//     textAlign: 'center',
//   },
//   footer: {
//     marginTop: '1.5rem',
//     textAlign: 'center',
//     fontSize: '0.9rem',
//   },
//   linkButton: {
//     background: 'none',
//     border: 'none',
//     color: '#007bff',
//     cursor: 'pointer',
//     textDecoration: 'underline',
//     fontSize: '0.9rem',
//   },
// };

// export default Login;


//otp auth version
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [otp, setOtp] = useState('');
//   const [useOtp, setUseOtp] = useState(false);
//   const [otpSent, setOtpSent] = useState(false);
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();

//   const PASSWORD_LOGIN_API = 'https://your-api-gateway.com/login';
//   const SEND_OTP_API = 'https://your-api-gateway.com/login/send-otp';
//   const VERIFY_OTP_API = 'https://your-api-gateway.com/login/verify-otp';
//   const API_KEY = 'your-public-api-key';

//   // ------------------------------
//   // PASSWORD LOGIN
//   // ------------------------------
//   const handlePasswordLogin = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       const res = await fetch(PASSWORD_LOGIN_API, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'x-api-key': API_KEY,
//         },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || 'Login failed');

//       localStorage.setItem('authToken', data.token);
//       navigate('/dashboard');
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ------------------------------
//   // SEND OTP
//   // ------------------------------
//   const handleSendOtp = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       const res = await fetch(SEND_OTP_API, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'x-api-key': API_KEY,
//         },
//         body: JSON.stringify({ email }),
//       });

//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || 'OTP send failed');

//       setOtpSent(true);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ------------------------------
//   // VERIFY OTP
//   // ------------------------------
//   const handleVerifyOtp = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       const res = await fetch(VERIFY_OTP_API, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'x-api-key': API_KEY,
//         },
//         body: JSON.stringify({ email, otp }),
//       });

//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || 'Invalid OTP');

//       localStorage.setItem('authToken', data.token);
//       navigate('/dashboard');
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.card}>
//         <h2 style={styles.header}>Welcome Back</h2>

//         {error && <div style={styles.error}>{error}</div>}

//         {/* LOGIN FORM */}
//         <form
//           onSubmit={
//             useOtp
//               ? otpSent
//                 ? handleVerifyOtp
//                 : handleSendOtp
//               : handlePasswordLogin
//           }
//           style={styles.form}
//         >
//           {/* Email */}
//           <div style={styles.inputGroup}>
//             <label style={styles.label}>Email</label>
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//               disabled={otpSent}
//               style={styles.input}
//             />
//           </div>

//           {/* PASSWORD */}
//           {!useOtp && (
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Password</label>
//               <input
//                 type="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//                 style={styles.input}
//               />
//             </div>
//           )}

//           {/* OTP */}
//           {useOtp && otpSent && (
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>OTP</label>
//               <input
//                 type="text"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 required
//                 style={styles.input}
//               />
//             </div>
//           )}

//           <button type="submit" disabled={loading} style={styles.button}>
//             {loading
//               ? 'Please wait...'
//               : useOtp
//               ? otpSent
//                 ? 'Verify OTP & Login'
//                 : 'Send OTP'
//               : 'Login'}
//           </button>
//         </form>

//         {/* Toggle */}
//         <div style={{ textAlign: 'center', marginTop: '10px' }}>
//           <button
//             onClick={() => {
//               setUseOtp(!useOtp);
//               setOtpSent(false);
//               setOtp('');
//               setPassword('');
//             }}
//             style={styles.linkButton}
//           >
//             {useOtp ? 'Login with password instead' : 'Login with OTP instead'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };


// // ---- Styles (UNCHANGED) ----
// const styles = {
//   container: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100vh',
//     backgroundColor: '#f0f2f5',
//   },
//   card: {
//     padding: '2rem',
//     borderRadius: '10px',
//     backgroundColor: 'white',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//     width: '100%',
//     maxWidth: '400px',
//   },
//   header: {
//     textAlign: 'center',
//     marginBottom: '1.5rem',
//     color: '#333',
//   },
//   form: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '1rem',
//   },
//   inputGroup: {
//     display: 'flex',
//     flexDirection: 'column',
//     textAlign: 'left',
//   },
//   label: {
//     marginBottom: '0.5rem',
//     fontSize: '0.9rem',
//     color: '#666',
//   },
//   input: {
//     padding: '0.75rem',
//     borderRadius: '5px',
//     border: '1px solid #ccc',
//     fontSize: '1rem',
//   },
//   button: {
//     padding: '0.75rem',
//     borderRadius: '5px',
//     border: 'none',
//     backgroundColor: '#007bff',
//     color: 'white',
//     fontSize: '1rem',
//     cursor: 'pointer',
//     marginTop: '1rem',
//   },
//   error: {
//     color: 'red',
//     backgroundColor: '#ffe6e6',
//     padding: '0.5rem',
//     borderRadius: '5px',
//     marginBottom: '1rem',
//     textAlign: 'center',
//   },
//   footer: {
//     marginTop: '1.5rem',
//     textAlign: 'center',
//     fontSize: '0.9rem',
//   },
//   linkButton: {
//     background: 'none',
//     border: 'none',
//     color: '#007bff',
//     cursor: 'pointer',
//     textDecoration: 'underline',
//     fontSize: '0.9rem',
//   },
// };

// export default Login;


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // ✅ REAL API GATEWAY LOGIN URL
  const API_URL =
    'https://f0kufr6w5f.execute-api.ap-south-1.amazonaws.com/praud/login';

  // ------------------------------
  // LOGIN HANDLER
  // ------------------------------
  const handleLogin = async (e) => {
  e.preventDefault();
  setError('');
  setLoading(true);

  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      const message = (data.message || '').toLowerCase();
      const errorDetail = (data.error || '').toLowerCase();

      if (
        message.includes('dynamodb') ||
        errorDetail.includes('accessdeniedexception')
      ) {
        throw new Error('Expired user');
      }

      if (message.includes('not found')) {
        throw new Error('User does not exist');
      }

      if (message.includes('password')) {
        throw new Error('Incorrect password');
      }
      if (message.includes('Invalid credentials')) {
        throw new Error('Invalid credentials');
      }

      throw new Error('Invalid credentials');
    }

    // ✅ SUCCESS
    localStorage.setItem('authToken', data.token);
    localStorage.setItem('userRole', data.role);
    localStorage.setItem('username', data.username);

    navigate('/adminDashboard/1234');
  } catch (err) {
    setError(err.message);
  } finally {
    setLoading(false);
  }
};


  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.header}>Welcome Back</h2>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={styles.input}
              placeholder="Enter your username"
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={styles.input}
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Verifying...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

// ---- Styles ----
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f2f5',
  },
  card: {
    padding: '2rem',
    borderRadius: '10px',
    backgroundColor: 'white',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '400px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    color: '#333',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  label: {
    marginBottom: '0.5rem',
    fontSize: '0.9rem',
    color: '#666',
  },
  input: {
    padding: '0.75rem',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '1rem',
  },
  button: {
    padding: '0.75rem',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#007bff',
    color: 'white',
    fontSize: '1rem',
    cursor: 'pointer',
    marginTop: '1rem',
  },
  error: {
    color: 'red',
    backgroundColor: '#ffe6e6',
    padding: '0.5rem',
    borderRadius: '5px',
    marginBottom: '1rem',
    textAlign: 'center',
  },
};

export default Login;
